import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectActiveTeam,
  selectActiveTeamOpposite,
  selectActiveTeamPlayerOptionsOpposite,
  selectActiveTeamPlayersOnTheFieldOptions,
} from 'features/match/matchSlice';

import { inputSliceActions, selectSelects } from 'features/input/inputSlice';

import AdvancedSelect from 'components/AdvancedSelect';

import { useIntl } from 'react-intl';
import generateSelectPlaceholder from '../../../helpers/generateSelectPlaceholder';
import selectOnChange from './helpers/selectOnChange';

interface EventInputPenaltyMissProps {
  penaltiesShootout: boolean;
}

const EventInputPenaltyMiss: React.FC<EventInputPenaltyMissProps> = (props) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const selects = useSelector(selectSelects);
  const playerOptions: any = useSelector(selectActiveTeamPlayersOnTheFieldOptions);
  const playerOptionsOpposite: any = useSelector(selectActiveTeamPlayerOptionsOpposite);
  const team: any = useSelector(selectActiveTeam);
  const teamOpposite: any = useSelector(selectActiveTeamOpposite);

  useEffect(() => {
    dispatch(inputSliceActions.setActiveSelect(selects.playerPenaltyKeeper.id));
  }, []);

  if (!team && !teamOpposite) return null;

  const teamName = team.shortName ? team.shortName : team.name;
  const teamNameOpposite = teamOpposite.shortName ? teamOpposite.shortName : teamOpposite.name;
  const playerMessage = intl.formatMessage({ id: 'eventInput.player' });

  const showKeeper = !props.penaltiesShootout || selects.playerPenaltyKeeper.value;

  const onChangePlayerKeeper = (option) => {
    selectOnChange(option, team, dispatch, intl);
    dispatch(inputSliceActions.setActiveSelect(selects.playerPenaltyKeeper.id));
  };

  return (
    <div className="input-group penalty-miss">
      <div className={'inputsLine' + (!showKeeper ? ' noKeeperInput' : '')}>
        <AdvancedSelect
          title={intl.formatMessage({ id: 'selectHeader.playerPenaltyTaker' })}
          placeholder={generateSelectPlaceholder(intl, playerMessage, teamName)}
          options={playerOptions}
          select={selects.playerPenaltyTaker}
          onChange={() => {
            dispatch(inputSliceActions.setActiveSelect(selects.playerPenaltyTaker.id));
          }}
          isClearable={false}
          disabled={true}
        />
        {showKeeper && (
          <AdvancedSelect
            title={intl.formatMessage({ id: 'selectHeader.playerPenaltySave' })}
            placeholder={generateSelectPlaceholder(intl, playerMessage, teamNameOpposite)}
            options={playerOptionsOpposite}
            select={selects.playerPenaltyKeeper}
            onChange={onChangePlayerKeeper}
            isClearable={true}
          />
        )}
      </div>
    </div>
  );
};

export default EventInputPenaltyMiss;
